import { gsap } from './gsap'

export const MIN_SCALE = 0.001

/**
 * Máscara circular hecha solo con transforms (sin clip-path, que repinta en
 * cada frame). El círculo escala desde `origin` y la capa interna aplica la
 * escala inversa para que el contenido quede quieto.
 */
export function setupCircle(mask, counter, area, origin, scale = MIN_SCALE) {
  const { x, y } = origin
  const radius = Math.hypot(Math.max(x, area.width - x), Math.max(y, area.height - y))

  Object.assign(mask.style, {
    position: 'absolute',
    left: `${x - radius}px`,
    top: `${y - radius}px`,
    width: `${radius * 2}px`,
    height: `${radius * 2}px`,
    borderRadius: '50%',
    overflow: 'hidden'
  })
  Object.assign(counter.style, {
    position: 'absolute',
    left: `${radius - x}px`,
    top: `${radius - y}px`,
    width: `${area.width}px`,
    height: `${area.height}px`,
    transformOrigin: `${x}px ${y}px`
  })

  const state = { scale }
  const apply = () => {
    mask.style.transform = `scale(${state.scale})`
    counter.style.transform = `scale(${1 / state.scale})`
  }
  apply()
  return { state, apply }
}

export const tweenCircle = (circle, scale, vars = {}) =>
  gsap.to(circle.state, {
    scale,
    duration: 1,
    ease: 'expo.inOut',
    onUpdate: circle.apply,
    ...vars
  })
